<template>
  <div class="main-box">
    <div class="top-bg">
      <img src="../../assets/show/top.png">
    </div>
    <div class="content-cls">
      <img src="../../assets/show/content_bg.png">
    </div>
    <div class="bottom-box">
<!--      <div class="msg-cls">想要默往专业版请提交申请<br>我们会安排工作人员1-3个工作日内跟您联系</div>-->
      <div class="btn-cls">申请已结束</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  created () {
    document.title = '默往专业版开放申请'
  }
}
</script>

<style scoped lang="scss">
.main-box{
  font-size: 0;
  background: url("../../assets/show/show_bg.png");
}
.top-bg img{
  width: 100%;
}
.content-cls{
  margin: 10px;
  img {
    width: 100%;
  }
}
.bottom-box{
  height: 40px;
  background: url("../../assets/show/show_bottom_bg.png") no-repeat;
  background-size: 100% 100%;
  text-align: center;
  font-size: 15px;
  color: #fff;
  padding: 10px 0 20px;
  .msg-cls{
    padding: 10px 0;
  }
  .btn-cls{
    text-align: center;
    background: #fff;
    border-radius: 25px;
    display: inline-block;
    width: 90%;
    height: 50px;
    line-height: 50px;
    color: #ccc;
    font-size: 18px;
  }
}
</style>
